import {
  renderTranslationString,
  TFunctionType,
  TranslationString
} from 'shared/entities/localization';
import { IPluginsStore } from 'shared/entities/store/pluginsStore';
import { IRootStore } from 'shared/entities/store/rootStore';

import { normalizeBase } from '../baseNormalizers';
import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../common';

import { ActionPortalOutNormalizer, IActionPortalOutExtraInfo } from './client';

export const normalizeActionPortalOut: ActionPortalOutNormalizer = (
  raw,
  stores: { rootStore: IRootStore; pluginsStore: IPluginsStore }
) => {
  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: raw.extra_info
          ? createActionPortalOutActualNameBase(
              raw.extra_info?.target?.scenario.name || '',
              raw.extra_info.target?.block
                ? normalizeBase(raw.extra_info.target.block, {
                    rootStore: stores.rootStore
                  }).actualName
                : '',
              t
            )
          : '',
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};

export const createActionPortalOutActualNameBase = (
  scenarioName: string,
  blockName: TranslationString | string,
  t: TFunctionType
): string => {
  const text = (t: TFunctionType) =>
    t('blockStaticConfigMap.portalOut.text', { ns: 'smartGraphBlocks' });

  const block = (t: TFunctionType) =>
    t('blockStaticConfigMap.portalOut.block', { ns: 'smartGraphBlocks' });

  const blockTitle = renderTranslationString(blockName, t);

  return `${text(t)} ${scenarioName} ${
    blockName ? `(${block(t)} ${blockTitle})` : ''
  }`;
};

export const createActionPortalOutActualName: ActualNameCreator<
  null,
  IActionPortalOutExtraInfo
> = ({ extraInfo, t }) => {
  if (extraInfo.target) {
    const name = createActionPortalOutActualNameBase(
      extraInfo.target.scenario.name,
      extraInfo.target.block?.actualName || '',
      t
    );
    return name;
  }
  return '';
};
